<template>
  <img  src="../../assets/share/play-video.svg" />
</template>


<script>

export default {
  name: "PlayButton",
  data() {
    return {
      imagePath: "../../assets/share/play-video.svg",
    }
  }
};
</script>

<style >

</style>

